// extracted by mini-css-extract-plugin
export var maxWidth = "staticHeroSimple-module--maxWidth--9g3oT";
export var container = "staticHeroSimple-module--container--VtW-p";
export var smallHeight = "staticHeroSimple-module--smallHeight--AmbHQ";
export var title = "staticHeroSimple-module--title--ihE-U";
export var description = "staticHeroSimple-module--description--unII-";
export var credit = "staticHeroSimple-module--credit--purbG";
export var slideUp = "staticHeroSimple-module--slideUp--FqAWa";
export var slideUpLarge = "staticHeroSimple-module--slideUpLarge--8++WT";